import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20abstract%20geometric%20network%20connection%20pattern%20with%20flowing%20curved%20lines%20and%20nodes%2C%20soft%20gradient%20texture%20background%2C%20minimalist%20modern%20digital%20design%2C%20clean%20professional%20corporate%20aesthetic%2C%20warm%20lighting%20with%20subtle%20depth%2C%20no%20text%20no%20people&width=1800&height=1000&seq=hero-bg-v1&orientation=landscape"
          alt="91.con 官方入口导航"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
          91.con <span className="text-primary-400">官方入口</span> · 最新地址导航
        </h1>
        <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          91.con 是用户热搜的网络平台入口，本页提供 91.con 最新可用地址、安全访问指引及常见问题解答，帮助用户快速找到 91.con 官方渠道，收藏本页随时获取最新更新。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/latest-address"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm whitespace-nowrap transition-all cursor-pointer"
          >
            <i className="ri-links-line text-lg"></i>
            查看最新地址
          </Link>
          <Link
            to="/category/faq"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full text-sm whitespace-nowrap backdrop-blur-sm border border-white/20 transition-all cursor-pointer"
          >
            <i className="ri-question-answer-line text-lg"></i>
            常见问题解答
          </Link>
        </div>

        {/* Stats */}
        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">50+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">收录地址</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">10万+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">月访问用户</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">24h</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">实时更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}